// <recently-viewed>: records the current product in localStorage and renders
// prior views as real _product-card markup, fetched via ?view=card.
//
// Storage keeps only the product URL. Cards used to be templated here from a
// stored title/image/price snapshot, which rendered instantly but drifted out of
// date and duplicated the card markup. Fetching the fragment costs one small
// request per item and gives live pricing, add-to-cart, the wishlist heart and
// quick-view for free.
customElements.define("recently-viewed", class extends HTMLElement {
  connectedCallback() {
    const KEY = "jg_recent";
    let list = [];
    try { list = JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { list = []; }
    let cur = null;
    try { cur = this.dataset.current ? JSON.parse(this.dataset.current) : null; } catch { cur = null; }

    if (cur && cur.url) {
      list = list.filter((p) => p.url !== cur.url);
      list.unshift(cur);
      list = list.slice(0, 8); // keep more than we show, so the list refills
      localStorage.setItem(KEY, JSON.stringify(list));
    }

    const limit = Number(this.dataset.limit) || 4;
    const others = list.filter((p) => p && p.url && (!cur || p.url !== cur.url)).slice(0, limit);
    const wrap = this.querySelector("[data-rv-list]");
    if (!others.length || !wrap) { this.hidden = true; return; }

    this.hidden = false;
    window.theme
      .renderProductCards(wrap, others.map((p) => ({ url: p.url, id: p.url })))
      .then(({ rendered, gone }) => {
        if (gone.length) {
          const keep = list.filter((p) => gone.indexOf(p.url) === -1);
          localStorage.setItem(KEY, JSON.stringify(keep));
        }
        if (!rendered) this.hidden = true; // every card failed or was deleted
      });
  }
});
